import * as type from '@app/constants/twrDevicesHealth'

export const fetchTwrDevicesHealth = () => ({
  type: type.FETCH_TWR_DEVICES_HEALTH,
})
